import React, { useContext, useState, useEffect } from "react";
import EditProfileForm from "./EditProfileForm";
import ModalImgInput from "./ModalImgInput";
import "./userProfile.scss";
import Header from "../Header";
import { getUserAvatar } from "../../utils/getMedia";
import { useNavigate } from "react-router-dom";
import { userDefaultImage } from "../../handleImgError";
import { UserProfileInfoContext } from "../../GlobalContext/UserProfileInfoContext";
import AuthClient from "../../api/AuthClient";
import GetUserProfileInfoApi from "../../api/GetUserProfileInfoApi";
import { parseUserProfileInfo } from "../../api/parseResponse/parseUserProfileInfo";
import ReactiveButton from "reactive-button";

type RequestState = 'idle' | 'loading' | 'success' | 'error';

const EditProfile: React.FC = () => {

  const [showModal, setShowModal] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
  const [saveRequestState, setSaveRequestState] = useState<RequestState>('idle');
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const { userProfileInfo, setUserProfileInfoContextData } = useContext(UserProfileInfoContext);

  const navigate = useNavigate();
  const isSavingProfile = saveRequestState === 'loading';

  // Fetch profile info if not already in context (handles page refresh)
  useEffect(() => {
    if (userProfileInfo.length === 0) {
      const authClient = new AuthClient();
      const userProfileInfoApi = new GetUserProfileInfoApi(authClient);

      userProfileInfoApi.getUserProfileInfo()
        .then((response) => {
          if (response?.data) {
            const parsedData = parseUserProfileInfo(response.data.profileInfo);
            setUserProfileInfoContextData([parsedData.userProfileInfo]);
          }
        })
        .catch((err) => {
          console.error("Error fetching profile info:", err);
          navigate('/');
        });
    }
  }, [userProfileInfo.length, setUserProfileInfoContextData, navigate]);

  if (userProfileInfo.length === 0) {
    return (
      <>
        <Header />
        <div className="centerGroup">
          <div className="desktopUI">
            <div className="text-center mt-5">Loading profile...</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="editProfilePage">
      <Header />
      <div className="centerGroup">
        <div className="desktopUI">
          <div className="row align-items-center profileTopActions">
            <div className="d-flex justify-content-start col-6">
              <button className='BtnTop yellowTxt btn text-decoration-none backBtn editProfileBackOverlay' onClick={() => navigate(-1)} disabled={isSavingProfile}>Back</button>
              
            </div>

            <div className="d-flex justify-content-end col-6">
              <ReactiveButton
                buttonState={saveRequestState}
                onClick={() => {
                  const form = document.getElementById('user-profile-form') as HTMLFormElement | null;
                  form?.requestSubmit();
                }}
                color={'yellow'}
                idleText={'Save'}
                loadingText={'Saving'}
                successText={'Saved'}
                errorText={'Error'}
                type={'button'}
                style={{ borderRadius: '20px', color: 'white', border: '1px solid #AF975A' }}
                outline={true}
                shadow={false}
                rounded={false}
                size={'small'}
                block={false}
                messageDuration={2000}
                disabled={isSavingProfile}
                buttonRef={null}
                width={null}
                height={null}
                animation={true}
              />
            </div>
          </div>
          <div className="container mt-3">
            <div className="box">
              <div className="justify-content-center d-flex align-content-center mt-3">
                {selectedImageFile ? (
                  <img
                    src={URL.createObjectURL(selectedImageFile)}
                    alt=""
                    className="ImgRoundProfile"
                  />
                ) : (
                  <img src={userProfileInfo[0].CountProfilePictures > 0 ? getUserAvatar(`${userProfileInfo[0].Id}?${Date.now()}`) : userDefaultImage()} alt="" className="ImgRoundProfile" />
                )}
              </div>

            <div className=" justify-content-center d-flex  align-content-center ">
                <button
                  onClick={handleShowModal}
                  className="btnChangeImg justify-content-center d-flex  align-content-center d-flex  col-6 mt-2 mb-3"
                  disabled={isSavingProfile}
                >
                  Change Image
                </button>
                <ModalImgInput showModal={showModal} handleCloseModal={handleCloseModal} onImageSelected={setSelectedImageFile} />
              </div>
            </div>

            <div className="FormBox box mt-3">
              <EditProfileForm selectedImageFile={selectedImageFile} onSaveStateChange={setSaveRequestState} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProfile;
